var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"config":_vm.config},on:{"cancel":function($event){return _vm.$emit('cancel')}}},[_c('div',{staticClass:"w-full h-full flex flex-col  bg-main-4 rounded-md",class:{
      'pb-20': !_vm.is_mip_activated,
      'pt-10': !_vm.is_mip_activated,
    }},[_c('transition',{attrs:{"name":"fade"}},[(_vm.is_modal_open)?_c('MIP',{staticClass:"w-full h-full"}):_vm._e()],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }